import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {AbstractControl, UntypedFormControl} from "@angular/forms";
import {ReactiveInputComponent} from "../reactive-input/reactive-input.component";
import {fromEvent, Subscription, take} from "rxjs";
import {filter} from "rxjs/operators";

@Component({
    selector: "app-reactive-edit-in-place",
    templateUrl: "./reactive-edit-in-place.component.html",
    styleUrls: ["./reactive-edit-in-place.component.scss"],
    standalone: false
})
export class ReactiveEditInPlaceComponent implements OnInit, OnDestroy{
    @ViewChild('reactiveInput') reactiveInput: ReactiveInputComponent;
    @Input() customErrorMessage: string;
    @Input() control: UntypedFormControl;
    @Input() placeholder: string;
    editMode = false;
    isHover = false;
    initialValue: string;
    clickSubscription: Subscription;

    constructor(private elementRef: ElementRef) {
    }

    ngOnInit() {
        //Set a validator on the FormControl's parent, so that the form is invalid when the control is in edit mode,
        // and there will be no error on the control itself
        this.control?.parent?.addValidators(this.editModeValidator.bind(this));
    }

    ngOnDestroy() {
        this.clickSubscription?.unsubscribe();
    }

    onEdit() {
        this.initialValue = this.control.value;
        this.editMode = true;
        setTimeout(() => {
            this.reactiveInput.input.elementRef.nativeElement.focus();
        }, 0);
        this.subscribeToClick();
        this.control.updateValueAndValidity();
    }

    subscribeToClick() {
        const clickOutside$ = fromEvent(document, 'click').pipe(
            filter((t) => {
                // @ts-ignore
                return this.elementRef.nativeElement.contains(t.target) === false && t.target.classList.contains('reactive-edit-in-place-button');
            }),
            take(1)
        );
        this.clickSubscription = clickOutside$.subscribe(() => this.onCancelEdit());
    }

    onCancelEdit() {
        this.control.setValue(this.initialValue);
        this.changeToViewMode();
    }

    onConfirmEdit() {
        if (!this.control.valid) {
            return;
        }
        this.control.setValue(this.control.value, {emitEvent: false}); //A workaround to trigger value change
        this.changeToViewMode();
    }

    changeToViewMode() {
        this.editMode = false;
        this.isHover = false;
        this.control.updateValueAndValidity();
        this.clickSubscription?.unsubscribe();
    }

    editModeValidator(control: AbstractControl): { [key: string]: any } | null {
        if (this.editMode) {
            return {editModeInvalid: true};
        }
        return null;
    }
}
